import { ResolutionString } from '../../charting_library';

const intervalMapping = {
    '1S': '1s',
    '1': '1m',
    '5': '5m',
    '15': '15m',
    '30': '30m',
    '60': '1h',
    '120': '2h',
    '180': '3h',
    '240': '4h',
    '1D': '1d',
};

const flip = <T extends PropertyKey, U extends PropertyKey>(data: Record<T, U>) =>
    Object.fromEntries(
        Object.entries(data).map(([key, value]) => [value, key])
    ) as Record<U, T>;

/** Converts TradingView interval to Binance interval format */
export const convertInterval = (interval: ResolutionString, reverse: boolean = false) => {
    if (reverse) {
        const reversed = flip(intervalMapping);

        return reversed[interval];
    }

    return intervalMapping[interval as keyof typeof intervalMapping];
};
